<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <material-card class="v-card-profile">
        <v-avatar slot="offset" class="mx-auto d-block" size="130">
          <img :src="`./img/juntos_icon.png`" />
        </v-avatar>
        <v-card-text class="text-xs-center">
          <h5 class="category text-gray font-weight-thin mb-3">
            {{ user.email }}
          </h5>
          <h3 class="card-title font-weight-light">
            Oi{{
              user.name != null ? ", " + user.name.replace(/ .*/, "") : ""
            }}!
          </h3>
          <h4 class="card-description">
            Concentramos todos os serviços em nosso App. Baixe agora mesmo e
            tenha acesso há:👇
          </h4>
          <v-list subheader three-line>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title
                  >Acompanhamento de Economia</v-list-tile-title
                >
                <v-list-tile-sub-title
                  >Acompanhe suas faturas, veja quanto está economizando, veja o
                  status de pagamento, faça a emissão de segunda
                  via.</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Atendimento Rápido</v-list-tile-title>
                <v-list-tile-sub-title
                  >No app você pode entrar diretamente em contato com nosso
                  time, basta clicar no icone do
                  WhatsApp.</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Forma de Pagamento</v-list-tile-title>
                <v-list-tile-sub-title
                  >Escolha como quer pagar suas faturas, boleto ou cartão de
                  crédito.</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Compartilhe com os amigos</v-list-tile-title>
                <v-list-tile-sub-title
                  >Conte para os amigos e familiares como você está economizando
                  e ganhe mais R$30,00 por amigo que assinar a
                  Enercred.</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>E muito mais...</v-list-tile-title>
                <v-list-tile-sub-title
                  >Receba notificações em tempo real, veja seu contrato, tire
                  dúvidas no nosso FAQ, veja nossa politica de privacidade e
                  muito mais.</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <div class="text-xs-center mt-4 mb-4">
          <a
            href="https://play.google.com/store/apps/details?id=com.enecred.enercredapp"
            target="_blank"
          >
            <img
              class="ml-4 mr-2"
              src="https://enercred.com.br/wp-content/themes/enercred-1/assets/min-images/google-play-2.png"
            />
          </a>
          <a
            href="https://apps.apple.com/br/app/enercred/id1465641135"
            target="_blank"
          >
            <img
              class="ml-2 mr-4"
              src="https://enercred.com.br/wp-content/themes/enercred-1/assets/min-images/app-store-2.png"
            />
          </a>
        </div>
      </material-card>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["user"]),
  },
  filters: {
    formatarData: function (value) {
      if (!value) return "";
      // value = value.toString()
      let timestamp = value; // firebase data
      let myDate = new Date(timestamp._seconds * 1000); // date object
      return moment(myDate.toISOString().substr(0, 10)).format("DD/MM/YYYY");
    },
  },
};
</script>
